module.exports = __webpack_public_path__ + "img/playngo.71c01ee1.png";